import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { getShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ToastBody, ToastStyle } from "@waytek/MobiusOverrides/Toast/Toast";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import parse from "html-react-parser";
import * as React from "react";
import { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    content = "content",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.content]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    shipTosDataView: getShipTosDataView(state, state.pages.addresses.getShipTosParameter),
    addressFieldDataView: getAddressFieldsDataView(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface OrderDetailsTitleStyles {
    wrapper?: InjectableCss;
}

export const titleStyles: OrderDetailsTitleStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-start;
            padding: 0;
            width: 100%;
            max-width: 100%;
            box-shadow: none;

            & > div {
                box-shadow: none;

                ${TypographyStyle} {
                    & > p:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        `,
    },
};

const styles = titleStyles;

const SectionTitle: FC<Props> = ({ fields,shipTosDataView,addressFieldDataView }) => {
    if (shipTosDataView.isLoading || !shipTosDataView.value || !addressFieldDataView.value) {
        return <></>
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <ToastStyle
                transitionState="entered"
                transitionLength={0}
                messageType="warning"
                data-test-selector="AccountSettings_Message"
            >
                <ToastBody data-id="toast-body">
                    <Typography>{parse(fields.content, parserOptions)}</Typography>
                </ToastBody>
            </ToastStyle>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SectionTitle) as any,
    definition: {
        allowedContexts: ["AddressesPage"],
        group: "Addresses",
        displayName: "Address Message",
        fieldDefinitions: [
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue:
                    '<p>If you need to change your billing or shipping address, please call <a href="tel:+8003282724">800.328.2724</a> or e-mail <a href="mailto:sales@waytekwire.com">sales@waytekwire.com</a></p>',
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
